export default __webpack_public_path__ + "static/827-6a71bcd9fe55ee93dc7626d8d54c5451.gif";